import ReactPaginate from 'react-paginate'

import { cn } from '#/lib/utils'

type PaginationProps = {
  pageCount: number
  currentPage: number
  onPageChange: (page: number) => void
  className?: string
}

export default function Pagination({
  pageCount,
  currentPage,
  onPageChange,
  className,
}: PaginationProps) {
  return (
    <ReactPaginate
      breakLabel="..."
      nextLabel="Next"
      onPageChange={(event) => onPageChange(event.selected)}
      pageRangeDisplayed={3}
      marginPagesDisplayed={1}
      pageCount={pageCount}
      previousLabel="Prev"
      forcePage={currentPage}
      containerClassName={cn(
        'flex flex-wrap items-center justify-center gap-2 rounded-full bg-white px-3 py-2 shadow-[0px_4px_20px_0px_rgba(106,155,145,0.16)]',
        className,
      )}
      pageClassName=""
      pageLinkClassName="flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold text-[color:var(--neutral-600)] transition hover:bg-[color:var(--primary-100)]"
      activeLinkClassName="bg-[color:var(--primary-500)] text-[color:var(--neutral-900)]"
      previousLinkClassName="flex h-10 items-center justify-center rounded-full px-4 text-sm font-semibold text-[color:var(--neutral-700)] transition hover:bg-[color:var(--primary-100)]"
      nextLinkClassName="flex h-10 items-center justify-center rounded-full px-4 text-sm font-semibold text-[color:var(--neutral-700)] transition hover:bg-[color:var(--primary-100)]"
      disabledLinkClassName="pointer-events-none opacity-50"
      breakLinkClassName="flex h-10 w-10 items-center justify-center rounded-full text-sm font-semibold text-[color:var(--neutral-500)]"
    />
  )
}
